export default {
  props: {
    flag: {
    	type: [String,Number,Boolean],
    	require: true
    }
  }
}
